'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var React = require('react');
var utils = require('@chakra-ui/utils');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["children", "className"];
/**
 * Pagination ellipsis
 *
 * Renders an ellipsis for the pagination component.
 */
var PaginationEllipsis = react.forwardRef(function (props, ref) {
  props.children;
  var className = props.className,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  var styles = react.useStyles();
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({
    className: utils.cx('chakra-pagination-ellipsis', className),
    __css: styles.ellipsis
  }, rest, {
    ref: ref
  }), "\u2026");
});
PaginationEllipsis.displayName = 'PaginationEllipsis';
exports.PaginationEllipsis = PaginationEllipsis;